export const COPY_FEEDBACK_TIMEOUT_MS = 3000;
